<template>
  <div class="mt-7">
    <div class="d-flex flex justify-center" v-if="loading">
      <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
    </div>
    <v-stepper v-model="step" class="elevation-0" v-else>
      <v-stepper-header class="elevation-0" v-show="showStepperHeader">
        <div class="d-flex flex-row justify-space-around flex text-center justify-center">
          <div class="d-flex flex-column ">
            <v-stepper-step
              class="pb-2"
              step="1"
              :complete="step > 1"
              :color="step > 1 ? 'success' : 'primary'"
            ></v-stepper-step>
            Upload
          </div>
          <div class="d-flex flex-column">
            <v-stepper-step
              class="pb-2"
              step="2"
              :complete="step > 2"
              :color="step > 2 ? 'success' : 'primary'"
            ></v-stepper-step>
            Informaçoes
          </div>
          <div class="d-flex flex-column">
            <v-stepper-step
              class="pb-2"
              step="3"
              :complete="step > 3"
              :color="step > 3 ? 'success' : 'primary'"
            ></v-stepper-step>
            Sucesso
          </div>
        </div>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <UploadAtestado @file-uploaded="fileUploaded" :arquivo="atestado.arquivo" />
        </v-stepper-content>
        <v-stepper-content step="2">
          <AtestadoInfoForm
            :atestado="atestado"
            @atestado-saved="atestadoSaved()"
            @go-to-upload-file="step = 1"
          /> </v-stepper-content
        ><v-stepper-content step="3">
          <AtestadoSuccess v-if="step === 3" @change-show-stepper-header="changeShowStepperHeader" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import UploadAtestado from './UploadAtestado'
import AtestadoInfoForm from './AtestadoInfoForm'
import AtestadoSuccess from './AtestadoSuccess'
import atestadoService from '@/services/atestado'

export default {
  name: 'UploadAtestadoStepper',
  props: {
    atestadoId: Number
  },
  components: {
    UploadAtestado,
    AtestadoInfoForm,
    AtestadoSuccess
  },
  data() {
    return {
      step: '1',
      showStepperHeader: true,
      atestado: {
        arquivo: null,
        tipo: null,
        documento: null,
        nome: null,
        cids: [],
        dtEmissao: null,
        diasAfastamento: null,
        beneficiario: null,
        observacoes: null
      },
      loading: false
    }
  },
  methods: {
    getBase64(file) {
      const reader = new FileReader()
      reader.onload = event => {
        this.atestado.arquivo = event.target.result
        this.atestado.arquivoAlterado = true
      }
      reader.readAsDataURL(file)
    },
    fileUploaded(file) {
      this.atestado.arquivo = file
      this.atestado.arquivoAlterado = true
      this.step = 2
    },
    atestadoSaved() {
      this.step = 3
    },
    changeShowStepperHeader(value) {
      this.showStepperHeader = value
    },
    async getAtestadoById() {
      try {
        this.loading = true
        const { data } = await atestadoService.getAtestadoById(this.atestadoId)
        this.atestado = data.atestado
        this.atestado.cids = this.atestado.cids.map(cid => cid.codigo)
        this.atestado.dtEmissao = new Date(this.atestado.dtEmissao).toLocaleDateString('pt-br')

        const [number, state] = this.atestado.documento.split('-')
        this.atestado.documentNumber = number
        this.atestado.documentState = state

        this.atestado.observacoes = this.atestado.observacoes === 'null' ? '' : this.atestado.observacoes

        this.step = 2
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    if (this.atestadoId) {
      this.getAtestadoById()
    }
  }
}
</script>
